var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-recaptcha',{staticClass:"form-re-captcha",class:{ 'form-re-captcha--error': _vm.hasError },attrs:{"sitekey":_vm.key,"load-recaptcha-script":true},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}})
}
var staticRenderFns = []

export { render, staticRenderFns }